const GreaterThanCircleIcon = /*#__PURE__*/ [
  ["path", { d: "M10 8L13.3322 11.0203C14.2226 11.8273 14.2226 12.1727 13.3322 12.9797L10 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "1" }]
];

export { GreaterThanCircleIcon as default };
//# sourceMappingURL=GreaterThanCircleIcon.js.map
